import { render, staticRenderFns } from "./TechnicalSheet.vue?vue&type=template&id=60126f7b&"
import script from "./TechnicalSheet.vue?vue&type=script&lang=js&"
export * from "./TechnicalSheet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports